import React, {Component} from 'react';
import {formatAmount} from '../lib/payment-utils';

/**
 * Renders the section to show the fee if exists and the total payment amount.
 * expected properties:
 *  data
 *  config
 */
class ReviewPaymentTotalAmount extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {data, config} = this.props,
            {payments} = data,
            {messages} = config;
        return (
            <div className="row">
                <div className="col-12">
                    <div className="review-payment-container no-fee">
                        <div className="review-payment-box rpb-total-amount text-center">
                            <div className="review-payment-heading">
                                {messages["payment.totalAmount.label"]}
                            </div>
                            <div className="review-payment-amount">
                                {formatAmount(data.totalPaymentAmount)}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ReviewPaymentTotalAmount;